import { AbacoWebModule, RouterReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import myRoutes from "./routes";
import ProtocolApi from "./api/ProtocolApi";
import ProtocolVuexModule from './state';
import { createMenu } from './menu';
import { HTTPClient } from '@abaco/web-common/src/HTTP';
import FarmRegistryModule from "@abaco/farm-registry/src/modules/farm-registry/index";
import ActivitiesModule from "@abaco/activities-module/src/modules/activities-module/index";
import ProtocolActivityApi from './api/ProtocolActivityApi';
import VarietyAndPhaseApi from './api/VarietyAndPhaseApi';
import ProtocolPrescriptionApi from './api/ProtocolPrescriptionApi';
import GlobalStateModule from "@abaco/portal-global-state/src/modules/global-state/index";
import GenericAcitvityApi from "./api/GenericActivityApi";
import FertilizerPlanApi from "./api/FertilizerPlanApi";

export const MODULE_ID = "protocol_module";

interface ConstructorOptions {
    environment?: string;
}

export default class ProtocolModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    public readonly environment!: string;

    private apiCreated!: boolean;
    private prtApi!: ProtocolApi;
    private actApi!: ProtocolActivityApi;
    private varAndPhase!: VarietyAndPhaseApi;
    private prscApi!: ProtocolPrescriptionApi;
    private genAct!: GenericAcitvityApi;
    private ferplApi!: FertilizerPlanApi;

    readonly id = MODULE_ID;
    readonly routes = myRoutes;
    readonly globalComponents = globals;
    readonly vuexModule = new ProtocolVuexModule();;
    menu: MenuItem[] = [];

    constructor(options?: ConstructorOptions) {
        this.environment = options?.environment || "portal"
    }

    dependsOn = {
        [FarmRegistryModule.MODULE_ID]: () => new FarmRegistryModule(),
        [ActivitiesModule.MODULE_ID]: () => new ActivitiesModule(),
        [GlobalStateModule.MODULE_ID]: () => new GlobalStateModule()
    }

    onRouterReady(evt: RouterReadyEvent) {
        this.menu = createMenu(evt.router);
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const ProtocolApi = (await import("./api/ProtocolApi")).default;
        this.prtApi = new ProtocolApi(http);

        const ProtocolActivityApi = (await import("./api/ProtocolActivityApi")).default;
        this.actApi = new ProtocolActivityApi(http);

        const VarietyAndPhaseApi = (await import("./api/VarietyAndPhaseApi")).default;
        this.varAndPhase = new VarietyAndPhaseApi(http);

        const ProtocolPrescriptionApi = (await import("./api/ProtocolPrescriptionApi")).default;
        this.prscApi = new ProtocolPrescriptionApi(http);

        const GenericActivityApi = (await import("./api/GenericActivityApi")).default;
        this.genAct = new GenericActivityApi(http);

        const FertilizerPlanApi = (await import("./api/FertilizerPlanApi")).default;
        this.ferplApi = new FertilizerPlanApi(http);
    }

    public get protocolApi() {
        return this.prtApi;
    }

    public get activityApi() {
        return this.actApi;
    }

    public get varietyAndPhaseApi() {
        return this.varAndPhase;
    }

    public get prescriptionApi() {
        return this.prscApi;
    }

    public get genericActivityApi() {
        return this.genAct;
    }

    public get fertilizerPlanApi() {
        return this.ferplApi;
    }

}
